// Path: ./src/app/pages/StoreUploadedImagesList/styled.ts
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 40px;
  padding-top: 40px;
`;
export const FlyerItemImageWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;

  display: flex;
  flex-wrap: wrap;
  padding-left: 24px;
  align-items: center;

  @media (max-width: 810px) {
    justify-content: center;
    padding-left: 0px;
  }
`;
export const PaginationWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
`;

export const Element = styled.div`
  margin-left: 12px;
  margin-top: 12px;
`;
